module.exports = __webpack_public_path__ + "static/media/full-star.62e8587c.svg";